import { TrackingFeature } from '../types/feature';

export const AUFeature: TrackingFeature = {
  enabledFacebookCapiV2: true,
  enabledTrackProductPageViewMoreThan3: true,
  enabledDisplayShowroom: true,
};
